
@if (showPage()) {
  <div>
    <div class="ot-panel">
      <div class="ot-panel__header">
        @if (productCapabilities?.supportsHotfix && isMasterSystemOnline && isQuickAnalysisRequired) {
          <div class="ot-message ot-message--is-error">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
                    An analysis of the primary system must be completed before continuing.&nbsp;<a (click)="analyzeMasterSystemClicked()">Analyze primary system</a>
                    </p>
            </div>
          </div>
        }
        @if (productCapabilities?.supportsHotfix && isMasterSystemOnline && !isQuickAnalysisRequired && !isMasterSystemSelected) {
          <div class="ot-message ot-message--is-error">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
                        A primary system must be selected. Please review the error below.
                    </p>
            </div>
          </div>
        }
        @if (!isMasterSystemOnline) {
          <div class="ot-message ot-message--is-error">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
                        The agent on the primary system is offline.
                    </p>
            </div>
          </div>
        }
        @if (productCapabilities?.supportsHotfix && isMasterSystemOnline && !isQuickAnalysisRequired && isMasterSystemSelected && isResyncing) {
          <div class="ot-message ot-message--is-progress">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
                        Please wait while we resynchronzing instances...
                    </p>
            </div>
          </div>
        }
      </div>
      <div class="table-container">
        <app-datatable [identifier]="'product-comp-instance-table'" [cols]="componentTableCols" [rows]="componentTableRows"
          (actionmenuevent)="actionMenuClicked($event)" [isSortable]="false" (rowclickevent)="rowClick($event)" [title]="''"
        [showcheckboxes]="true" [recountSelectedRow]="recountSelectedRow" [overrideShowError]="true"></app-datatable>
      </div>
    </div>
  </div>
} @else {
  <div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter"></div>
    </div>
    @if (isLoading && !isManifestUpdating && !isAgentManifestUpdating) {
      <div class="ot-progress__text" i18n>Loading...</div>
    }
    @if (isManifestUpdating) {
      <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
    }
    @if (isAgentManifestUpdating) {
      <div class="ot-progress__text" i18n>Please wait while the Agent manifest is updated...</div>
    }
  </div>
}
